export default {"src":"/_next/static/media/offer_tick.a408fed1.svg","height":101,"width":116,"blurWidth":0,"blurHeight":0};